import { Item } from 'shared-types';

const STORAGE_KEY = 'basket_room_upgrades';

type StoredUpgrades = { basketId: string; itemIds: string[] };

const readStored = (): StoredUpgrades | undefined => {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null');
    if (!stored || typeof stored !== 'object') return undefined;
    const { basketId, itemIds } = stored as Partial<StoredUpgrades>;
    if (typeof basketId !== 'string' || !Array.isArray(itemIds)) return undefined;
    return { basketId, itemIds: itemIds.map(String) };
  } catch {
    return undefined;
  }
};

export const upgradedRoomIds = (basketId?: string | null): Set<string> => {
  const stored = basketId ? readStored() : undefined;
  return new Set(stored && stored.basketId === basketId ? stored.itemIds : []);
};

export const markRoomUpgraded = (basketId: string | null | undefined, itemId: Item['id']) => {
  if (!basketId || itemId == null) return;
  const itemIds = [...upgradedRoomIds(basketId), String(itemId)];
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ basketId, itemIds }));
  } catch {
    return;
  }
};
